<script>
    export let person_buckets = {};
    export let chosen_letter = '';
</script>

<div class="mt-4 font-mono -space-x-px -space-y-px" aria-label="Pagination"
>{#each Object.keys(person_buckets) as letter}<span
        on:click={() => chosen_letter = letter}
        class="relative inline-flex items-center border -ml-px px-3 py-2 text-sm font-medium {letter === chosen_letter ? `z-10 bg-indigo-50 border-indigo-500 text-indigo-600` : `bg-white border-gray-300 text-gray-500 hover:bg-gray-50`} focus:z-20"
>{letter}</span>{/each}</div>


<style></style>